import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { IAlyceCustomTheme } from '../../../../../styles/alyceTheme';
import { getIsPreview } from '../../../store/statuses/statuses.selectors';

const useStyles = makeStyles<IAlyceCustomTheme, { isPreview: boolean }>(({ palette }) => ({
  declineLink: ({ isPreview }) => ({
    color: palette.customStyling.highlightColor,
    fontWeight: 'bold',
    pointerEvents: isPreview ? 'none' : undefined,
    opacity: isPreview ? 0.5 : 1,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'none',
    },
  }),
}));

export interface IDeclineLinkProps {
  href: string;
}

const DeclineLink = ({ href }: IDeclineLinkProps): JSX.Element => {
  const isPreview = useSelector(getIsPreview);
  const classes = useStyles({ isPreview });
  return (
    <Box fontFamily="Lato" textAlign="center" my={4}>
      <Link data-testid="giftDeclineButton" className={classes.declineLink} to={href}>
        I&apos;m not interested
      </Link>
    </Box>
  );
};

export default DeclineLink;
